import { createIcon } from '@chakra-ui/icons'

const TXTIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g transform="translate(5311 -4734.065)">
      <path
        d="M-5242.5 4817.5h-59c-2.5 0-4.5-2-4.5-4.5v-71c0-2.5 2-4.5 4.5-4.5h44.4l19.1 17.3v58.2c0 2.5-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M-5242.5 4817c2.2 0 4-1.8 4-4v-58l-18.8-17h-44.2c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5v-71c0-2.8 2.2-5 5-5h44.6l19.4 17.6v58.4c0 2.8-2.3 5-5 5z"
        fill="#E1E4EA"
      />
      <path
        d="M-5237.5 4767h-69v-25c0-2.8 2.2-5 5-5h45.6l18.4 17.5v12.5z"
        fill="#1A7186"
      />
      <path
        d="M-5255.8 4737.1v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0l-18.2-17.4z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(-5299.533 4756.032)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        TXT
      </text>
      <path
        fill="#E1E4EB"
        d="M-5290.1 4801.9h13.9v5.9c0 .4.3.8.8.8.2 0 .4-.1.5-.2l6.5-6.5h14.4c.4 0 .8-.3.8-.8v-23.9c0-.4-.3-.8-.8-.8h-36.1c-.4 0-.8.3-.8.8v23.9c.1.4.4.8.8.8zm.8-23.9h34.6v22.4h-13.9c-.2 0-.4.1-.5.2l-5.4 5.4v-4.9c0-.4-.3-.8-.8-.8h-13.9V4778z"
      />
      <path
        fill="#E1E4EB"
        d="M-5283.4 4783.2h22.7c.4 0 .8-.3.8-.7 0-.4-.3-.8-.7-.8h-22.8c-.4 0-.7.4-.7.8s.3.7.7.7z"
      />
      <path
        fill="#E1E4EB"
        d="M-5283.4 4789.9h22.7c.4 0 .8-.3.8-.7 0-.4-.3-.8-.7-.8h-22.8c-.4 0-.7.4-.7.8s.3.7.7.7z"
      />
      <path
        fill="#E1E4EB"
        d="M-5259.9 4795.9c0-.4-.3-.8-.8-.8h-22.7c-.4 0-.8.3-.8.7s.3.8.7.8h22.8c.4.1.8-.3.8-.7z"
      />
    </g>
  ),
})

export default TXTIcon
